
























import Vue from "vue";
export default Vue.extend({
  props: {
    item: { type: Object, required: true },
    /** false when the previous period predates the org's first data */
    show_relative: { type: Boolean, default: true },
  },
});
